export const convertDateFromString = (string) => {
  const date = string.split('.')
  return new Date(date[2], date[1] - 1, date[0])
}
